import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import ArrowIcon from '@material-ui/icons/PlayArrow';

import Icon from '@components/Icon/Icon';

import './CasePreview.scss';
import '@components/Link/Link.scss';

const CasePreview = ({ data }) => (
  <div className="case-preview">
    <div className="case-preview__left-card">
      <div className="case-preview__left-card-title">
        Bankruptcy case <br />
        administrator
      </div>
      <div className="case-preview__info-list">
        <div className="case-preview__info-list-item">
          <Icon className="case-preview__info-list-item-icon">
            <ArrowIcon />
          </Icon>
          <div className="case-preview__info-list-item-text">
            <span className="case-preview__info-list-item-text--bold">
              PACER
            </span>
            &nbsp;
            Integration
          </div>
        </div>
        <div className="case-preview__info-list-item">
          <Icon className="case-preview__info-list-item-icon">
            <ArrowIcon />
          </Icon>
          <div className="case-preview__info-list-item-text">
            <span className="case-preview__info-list-item-text--bold">
              eDiscovery
            </span>
            &nbsp;
            and
            &nbsp;
            <span className="case-preview__info-list-item-text--bold">
              Forensics
            </span>
          </div>
        </div>
        <div className="case-preview__info-list-item">
          <Icon className="case-preview__info-list-item-icon">
            <ArrowIcon />
          </Icon>
          <div className="case-preview__info-list-item-text">
            Contact Center
          </div>
        </div>
      </div>
    </div>
    <div className="case-preview__right-card">
      <div className="case-preview__right-card-title">
        Recent Active Cases
      </div>
      {data.length > 0 && (
        <div className="case-preview__case-list">
          {data.map(({
            caseNumber,
            id,
            name,
          }) => (
            <div
              className="case-preview__case-list-item"
              key={id}
            >
              <div className="case-preview__case-list-item-number">
                <RouterLink
                  to={`/cases/${id}`}
                  className="link"
                >
                  {caseNumber}
                </RouterLink>
              </div>
              <div className="case-preview__case-list-item-name">
                {name}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="case-preview__link-wrapper">
        <RouterLink
          to="/cases"
          className="link"
        >
          Search for more
        </RouterLink>
      </div>
    </div>
  </div>
);

CasePreview.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    caseNumber: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
};

export default CasePreview;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/CasePreview/CasePreview.js